import { render, staticRenderFns } from "./schedule-event.vue?vue&type=template&id=6c824961&scoped=true&"
import script from "./schedule-event.vue?vue&type=script&lang=js&"
export * from "./schedule-event.vue?vue&type=script&lang=js&"
import style0 from "./schedule-event.vue?vue&type=style&index=0&id=6c824961&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c824961",
  null
  
)

export default component.exports